// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lz-3";
export var downloadButton = "_lz-4";
export var fileContainer = "_lz-9 _lz-7";
export var fileContainerBase = "_lz-7";
export var fileContainerFixedHeight = "_lz-8 _lz-7";
export var fileInfo = "_lz-5";
export var fileInfoWidthRestricted = "_lz-6";
export var fileType = "_lz-1";
export var fileTypeName = "_lz-2";
export var image = "_lz-0";
export var link = "_lz-b";
export var overflowEllipsis = "_lz-a";